import React from 'react'

import { TransactionReconciliationDocument } from 'generated/resources/graphql'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import { useQuery } from 'modules/core/hooks/useQuery'

import { NewReconciliationForm } from 'modules/banking/components/NewReconciliationForm'

interface Props {
  transactionId: number | undefined | null
  onTransactionFullyReconciled: () => void
  onInvoiceDetailClick: (id: number, expensableId?: number) => void
}

export const ReconcileTransaction: React.FC<Props> = ({
  transactionId,
  onTransactionFullyReconciled,
  onInvoiceDetailClick
}: Props) => {
  const { company } = useCurrentSession()

  const [showSuggestions, setShowSuggestions] = React.useState<boolean>(true)

  const { data, loading } = useQuery(TransactionReconciliationDocument, {
    variables: { companyId: company.id, transactionId: Number(transactionId) },
    skip: !transactionId
  })
  const transaction = transactionId ? data?.banking?.transaction : null

  return (
    <NewReconciliationForm
      transaction={transaction}
      loading={loading}
      onTransactionFullyReconciled={onTransactionFullyReconciled}
      onInvoiceDetailClick={onInvoiceDetailClick}
      showSuggestions={showSuggestions}
      setShowSuggestions={setShowSuggestions}
    />
  )
}
